export type AppLocale = 'en' | 'es'

function canonicalLocale(value: unknown): AppLocale | null {
  if (typeof value !== 'string') return null
  const normalized = value.trim().toLocaleLowerCase('en-US').replaceAll('_', '-')
  if (normalized === 'english' || normalized === 'en' || normalized.startsWith('en-')) return 'en'
  if (normalized === 'spanish' || normalized === 'español' || normalized === 'espanol' || normalized === 'es' || normalized.startsWith('es-')) return 'es'
  return null
}

export function parseAppLocale(value: unknown): AppLocale | null { return canonicalLocale(value) }

export function isAppLocale(value: unknown): value is AppLocale {
  return value === 'en' || value === 'es'
}

/** Normalize legacy profile, storage, browser, and device values into the API contract. */
export function normalizeAppLocale(value: unknown, resolvedLocale: unknown = 'en'): AppLocale {
  return canonicalLocale(value) ?? canonicalLocale(resolvedLocale) ?? 'en'
}

/** Logs only locale metadata; never user-authored text or identifiers. */
export function traceAppLocale(boundary: string, value: unknown, normalized: AppLocale, enabled = false) {
  if (!enabled) return
  console.debug('[app-locale]', {
    boundary,
    inputType: value === null ? 'null' : typeof value,
    inputValue: typeof value === 'string' ? value.slice(0, 32) : value == null ? String(value) : '[non-string]',
    normalized,
  })
}
